import { getConfigForImportedTest } from 'Components/Worksheets/Config';
import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import qestIds from '../../../QestIds';
import { NuclearDensityGaugeMode } from '../../types';
import getLabelConfig from './labelConfig';
const probeCountConfig = { format: { nearest: 1 } };
const densityConfig = { uom: 'kg/m³', format: { nearest: 1 } };
const ratioConfig = { format: { nearest: 0.001 } };

const getConfig = (prefix: string) =>
  mergeConfig(
    {
      //Preparation
      [`${prefix}.Preparation.LayerDepth`]: { uom: 'mm', format: { nearest: 1 } },
      [`${prefix}.Preparation.DensityStandardCount`]: probeCountConfig,
      [`${prefix}.Preparation.MoistureStandardCount`]: probeCountConfig,

      //Measurements
      [`${prefix}.Measurements.Depth`]: { uom: 'mm', format: { nearest: 1 } },
      [`${prefix}.Measurements.WetDensity`]: densityConfig,
      [`${prefix}.Measurements.MoistureDensity`]: densityConfig,
      [`${prefix}.Measurements.MoistureContent`]: { format: { nearest: 0.1 } },
      [`${prefix}.Measurements.NuclearDensityGaugeMode`]: {
        options: [{ label: 'Direct Transmission', value: NuclearDensityGaugeMode.DirectTransmission }],
      },

      //Readings
      [`${prefix}.Measurements.Readings.DensityTestCount`]: probeCountConfig,
      [`${prefix}.Measurements.Readings.MoistureTestCount`]: probeCountConfig,
      [`${prefix}.Measurements.Readings.DensityCountRatio`]: ratioConfig,
      [`${prefix}.Measurements.Readings.MoistureCountRatio`]: ratioConfig,

      //Associated MC
      [`${prefix}.AssociatedLabMoistureContent.ExternalTest.Results.MoistureContentPercent`]: {
        format: { nearest: 0.1 },
      },
      ...getConfigForImportedTest(
        qestIds.moistureContent.AS_1289_2_1_1.rev2005,
        `${prefix}.AssociatedLabMoistureContent`
      ),
      [`${prefix}.LabMoistureContent`]: { format: { nearest: 0.1 } },

      //Results
      [`${prefix}.Results.InsituMoistureContent`]: { format: { nearest: 0.1 } },
      [`${prefix}.Results.InsituDryDensity`]: { uom: 't/m³', format: { nearest: 0.001 } },
      [`${prefix}.Results.InsituWetDensity`]: { uom: 't/m³', format: { nearest: 0.001 } },
    },
    getLabelConfig(prefix)
  );

export { getConfig };

export default {
  [qestIds.nuclearFieldDensity.AS_1289_5_8_1.rev2007]: getConfig,
};
